'use client'
import { removeDialCode, getActiveFormattingMask } from 'react-international-phone';

/** Whether phone number length matches the expectation for this country */
const validatePhoneLength = (phone, country) => removeDialCode({ dialCode: country.dialCode, phone }).length ===
    getActiveFormattingMask({
        country,
        disableFormatting: true,
        phone,
    }).length;

export { validatePhoneLength };
